<script>
import CountDown from './countDown'
import { apiService } from '@/helpers/api.service';
import { EventBus } from '@/eventBus';
import { firstArrMinute, lastArrMinute } from '@/utils/utilsDate';
import Swal from 'sweetalert2';
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';
import PermissionTooltip from '@/components/permission-tooltip.vue';


export default {
    components: { CountDown, PermissionTooltip },
    props: {
        order: {
            type: Object,
            default: null,
        },
        column: String,
        popoverShow: {
            type: Boolean,
            default: false,
        },
        popoverShowDeliver: {
            type: Boolean,
            default: false,
        },
        detailTotal: {
            type: Boolean,
            default: false,
        },
        timeOptions: {
            type: Array,
            default: null,
        },
        time: {
            type: Number,
            default: 15,
        },
        timeToggle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            user: null,
            timeLeft: Number,
            riderErrorMessage: false,
            isSubmitting: false,
            showTooltip: false,
            showAcceptTooltip: false,
            showReadyTooltip: false,
        };
    },
    computed: {
        formattedTime() {
            if (this.order) {
                const dateObj = new Date(this.order.createdAt);
                const hours = String(dateObj.getHours()).padStart(2, '0');
                const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                return `${hours}:${minutes} hs`;
            }
            return null
        },
    },
    mounted() {
        const user = JSON.parse(localStorage.getItem('user'));
        this.user = user
        this.canUpdateStoreOpen()
        this.canCancelOrder()
        this.canStorePrepareOrder()
    },
    methods: {
        canUpdateStoreOpen() {
            return checkPermission(permissionsMap.ACCEPT_STORE_ORDER, this.$store.state.permissions);
        },
        canCancelOrder() {
            return checkPermission(permissionsMap.CANCEL_STORE_ORDER, this.$store.state.permissions);
        },
        getCount(options, name) {
            return options.filter(option => option.name === name).length;
        },
        canStorePrepareOrder() {
            return checkPermission(permissionsMap.PREPARE_STORE_ORDER, this.$store.state.permissions);
        },
        getUniqueOptions(options) {
            const uniqueOptions = [];
            options.forEach(option => {
                if (!uniqueOptions.some(o => o.name === option.name)) {
                    uniqueOptions.push(option);
                }
            });
            return uniqueOptions;
        },
        setDetailTotal() {
            this.detailTotal = !this.detailTotal;
        },
        setTime(time) {
            this.time = time;
        },
        toggleTimeOptions() {
            this.timeOptions = this.timeToggle ? lastArrMinute : firstArrMinute;
            this.timeToggle = !this.timeToggle;
        },
        submitOrder(status) {
            this.isSubmitting = true;
            let body = {
                "newStatusCode": `${status}`
            }
            if (status == 'preparing') {
                body = {
                    "newStatusCode": `${status}`,
                    "estimatedTime": this.time
                }
            }
            apiService.patchOrderId(this.order._id, body)
                .then((res) => {
                    if (res === 'error') {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Ocurrió un error al actualizar el pedido.",
                            showConfirmButton: false,
                            timer: 4500
                        })
                        this.riderErrorMessage = true
                        setTimeout(() => { this.riderErrorMessage = false }, 5000);
                    } else {
                        this.riderErrorMessage = false
                        this.$emit('update-status', status, this.order._id, this.time)
                        this.$bvModal.hide('infoOrder')
                        EventBus.$emit('stop-sound');
                    }
                })
                .catch(() => { 
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrió un error al actualizar el pedido.",
                        showConfirmButton: false,
                        timer: 4500
                    })
                })
                .finally(() => {
                this.isSubmitting = false; 
            });
        },
    },
}
</script>

<template>
    <b-modal id="infoOrder" centered size="lg" hide-footer="true" class="detail">

        <div class="row">
            <div class="col-md-6 detail-order">
                <h4>Pedido <b>#{{ order?.code }}</b></h4>
                <div>
                    <img src="@/assets/time.svg" alt="time">
                    <h4>{{ formattedTime }}</h4>
                </div>
            </div>
            <div class="col-md-6 detail-customer-name" style="text-align:right;">
                <h5><b>Este pedido pertenece a:</b> {{ order?.customer.name }}</h5>
            </div>
        </div>

        <div>
            <table class="detail-table">
                <thead>
                    <tr class="text-header-table">
                        <th scope="col">Cant.</th>
                        <th scope="col">Plato elegido</th>
                        <th scope="col">Aclaración</th>
                        <th scope="col" style="text-align: end">Precio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(dish, index) in order?.dishes" :key="index">
                        <td>X{{ dish?.quantity }}</td>
                        <td>
                            {{ dish?.name }}
                            <br />
                            <div class="custom-dish"
                                v-if="dish.personalize.length > 0 && dish.personalize[0]?.options.length > 0">
                                <h4>SABOR:</h4>
                                <p v-for="(option, index) in getUniqueOptions(dish.personalize[0].options)" :key="index">
                                    {{ option.name }}
                                    <span class="quantityPersonalize"
                                        v-if="getCount(dish.personalize[0].options, option.name) > 1">
                                        (x{{ getCount(dish.personalize[0].options, option.name) }})</span>
                                    <span v-if="index !== getUniqueOptions(dish.personalize[0].options).length - 1">,</span>
                                </p>
                            </div>
                            <div class="custom-dish" v-if="dish.addon.length > 0 && dish.addon[0]?.options.length > 0">
                                <h4>EXTRA:</h4>
                                <div v-for="(option, index) in dish?.addon[0].options" :key="index">
                                    <p>{{ option.name }} <span v-if="index !== dish.addon[0].options.length - 1">,</span>
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td class="observations">{{ dish?.observations }}</td>
                        <td style="text-align:end; width: 155px">${{ dish?.subtotal }}</td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td>
                        </td>
                        <td></td>
                        <td></td>
                        <td style="width:25%;">
                            <div v-if="!detailTotal">
                                <div class="row">
                                    <div class="col-md-8" style="text-align:right;">

                                    </div>
                                    <div class="col-md-4" style="text-align:right;">

                                    </div>
                                    <div class="col-md-8" style="text-align:right;">
                                        <b>Valor Total:</b>
                                    </div>
                                    <div class="col-md-4" style="text-align:right;">
                                        <b>${{ order?.subtotal }}</b>
                                    </div>
                                </div>

                            </div>

                            <div v-if="detailTotal">
                                <div class="row detail-subtotal">
                                    <p class="col-md-8">Impuesto:</p>
                                    <p class="col-md-4">$0</p>
                                    <p class="col-md-8">Servicio Welly:</p>
                                    <p class="col-md-4">$0</p>
                                    <h5 class="col-md-8"><b>Valor Total:</b></h5>
                                    <h5 class="col-md-4"><b>${{ order?.subtotal }}</b></h5>
                                </div>

                                <div class="row detail-more detail-more-minus">
                                    <div class="col-md-12" style="text-align:right;">
                                        Ver detalle
                                        <button v-on:click="setDetailTotal">-</button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <br />

        <div v-if="column == 'news'" class="row col-md-12 detail-choose-time">
            <h4>¿Cuántos minutos te toma preparar esta orden?</h4>
            <br />
            <div class="detail-time-buttons">
                <div v-for="(timeOption, index) in timeOptions" :key="index">
                    <b-button v-bind:class="time == timeOption ? 'selected-time' : ''" pill variant="success" size="lg"
                        class="time-btn" v-on:click="setTime(timeOption)">
                        {{ timeOption }}'
                    </b-button>
                </div>
                <b-button v-show=timeToggle pill variant="success" size="lg" class="time-btn"
                    v-on:click="toggleTimeOptions()"> +
                </b-button>
                <b-button v-show=!timeToggle pill variant="success" size="lg" class="time-btn"
                    v-on:click="toggleTimeOptions()"> -
                </b-button>
            </div>
            <br />
        </div>
        <br />

        <div v-if="column != 'news'" class="detail-in-preparation">
            <div class="detail-preparation-time">
                <h4 v-show="column == 'preparing'">Tiempo de preparación: <span>{{ order?.prepTime }}´</span></h4>
                <h4 v-show="column == 'done'">Tiempo de preparación: <span>0´</span></h4>
                <div class="detail-remaining">
                    <p>Restantes</p>
                    <CountDown v-show="column == 'preparing'" :time="order?.prepTime"
                        :createdTime="order?.status?.createdAt" />
                    <CountDown v-show="column == 'done'" :time="0" />
                </div>
            </div>
            <div style="width: 50%">
                <div v-if="column == 'preparing' && order?.riderAtResto" class="detail-in-local">
                    <p>Ya está en el local.</p>
                </div>
                <div class="detail-wellyvery"
                    :class="column == 'preparing' && order?.riderAtResto ? 'detail-wellyvery-preparing' : ''">
                    <img src="@/assets/images/rabbit.svg" alt="rabbit">
                    <h3>Repartidor:</h3>
                    <div></div>
                    <div>
                        <p>{{ order?.rider?.name || "Aún no ha sido confirmado" }} </p>
                        <p v-show="order?.rider">Teléfono: +{{ order?.rider?.phone }}</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="row selectedTime">
            <div v-if="column == 'news'">
                <h5>Tiempo de preparación seleccionado: {{ time }}'</h5>
            </div>
            <div :class="column == 'news' ? col - md - 6 : col - md - 12">
                <div class="right">
                    <div style="display: inline-block; position: relative;" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
                        <PermissionTooltip 
                            :show="showTooltip && !canCancelOrder()"
                        />
                        <b-button href="#" type="submit" variant="success" class="btn-detail btn-cancel"
                            v-on:click="!popoverShowDeliver ? popoverShow = !popoverShow : null" :disabled="!canCancelOrder()">
                            Cancelar pedido
                        </b-button>
                    </div>
                    <div v-if="popoverShow | (popoverShowDeliver && column == 'done')" class="detail-popover"
                        :class="popoverShowDeliver ? 'detail-popover-deliver' : ''">
                        <p>{{ popoverShow ? '¿Cancelar pedido?' : '¿Entregar pedido?' }}</p>
                        <div class="popover-btn-container">
                            <button
                                v-on:click="popoverShow ? popoverShow = !popoverShow : popoverShowDeliver = !popoverShowDeliver"
                                class="btn-popover btn-popover-back">Volver</button>
                           <button v-bind:disabled="isSubmitting" v-on:click="popoverShow ? submitOrder('rejected') : submitOrder('picked')"
                                class="btn-popover btn-popover-cancel">
                                {{ popoverShow ? 'Cancelar pedido' : 'Entregar pedido' }}</button>
                        </div>
                    </div>
                    
                    <div v-if="column == 'news'" style="display: inline-block; position: relative; margin-right: 1rem;" @mouseenter="showAcceptTooltip = true" @mouseleave="showAcceptTooltip = false">
                        <PermissionTooltip 
                            :show="showAcceptTooltip && (!canUpdateStoreOpen() || !canStorePrepareOrder())"
                        />
                        <b-button href="#" type="submit" variant="success"
                            v-on:click="submitOrder('preparing')" v-bind:disabled="isSubmitting || !canUpdateStoreOpen() || !canStorePrepareOrder()" class="btn-detail btn-accept">
                            Aceptar pedido
                        </b-button>
                    </div>
                    <div v-if="column == 'preparing'" style="display: inline-block; position: relative; margin-right: 1rem;" @mouseenter="showReadyTooltip = true" @mouseleave="showReadyTooltip = false">
                        <PermissionTooltip 
                            :show="showReadyTooltip && (!canStorePrepareOrder() || !canUpdateStoreOpen())"
                        />
                        <b-button href="#" type="submit" variant="success"
                            v-on:click="submitOrder('prepared')" v-bind:disabled="isSubmitting || !canStorePrepareOrder() || !canUpdateStoreOpen()" class="btn-detail btn-accept">
                            Pedido listo
                        </b-button>
                    </div>
                    <b-button v-if="column == 'done'" href="#" type="submit" variant="success"
                        v-on:click="!popoverShow ? popoverShowDeliver = !popoverShowDeliver : null"
                        class="btn-detail btn-accept">
                        Pedido entregado
                    </b-button>
                    <div v-if="riderErrorMessage && column == 'done'" class="rider-error-msg">
                        <img src="@/assets/images/exclamation-triangle-red.svg" alt="error image">
                        <p v-if="!order.rider"> No hay un repartidor asignado </p>
                        <p v-if="order.rider"> El repartidor todavía no llegó al restó</p>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/popup/detailNewOrder';
</style>
